module.exports = __webpack_public_path__ + "cfa93a6a3c969f14ae012f52e4841bd9.svg";